<template>
  <div>
    <v-row class="common-card-row pb-3">
      <v-col
        v-for="(data, index) in config"
        :key="`filter_${index}`"
        :class="['pa-0 pb-3 pb-md-0', getLastItemClass(index)]"
      >
        <v-card
          flat
          :elevation="`${data.value == highlighted ? 3 : 0}`"
          class="pa-4 pointer"
        >
          <div
            :title="data.tooltip"
            @click="
              highlighted = data.value;
              $emit('card-click', data.value);
            "
            class="d-flex justify-space-between align-center"
          >
            <div>
              <v-card-subtitle
                class="pt-1 pb-0 pl-0"
                v-if="
                  values[data.value] &&
                  data.title.trim().toLowerCase() != 'no location'
                "
              >
                <b>{{ $numberWithCommas(values[data.value].devices) }}</b>
                Device(s) {{ data.title == "Outside known" ? "" : "in" }}
                <span v-if="data.title != 'Outside known'"
                  ><b>{{ values[data.value].locations }} </b></span
                >
                <span
                  ><b>{{ data.title }}</b></span
                >
                POI(s)
              </v-card-subtitle>
              <v-card-subtitle
                class="pt-1 pb-0"
                v-if="
                  values[data.value] &&
                  data.title.trim().toLowerCase() == 'no location'
                "
              >
                <b>{{ $numberWithCommas(values[data.value].devices) }}</b>
                Device(s) with
                <span
                  ><b>{{ data.title }}</b></span
                >
                data
              </v-card-subtitle>
            </div>
            <div>
              <TooltipVT
                v-if="data"
                :icon="data.icon"
                :color="data.color"
                type="btn"
                :text="data.tooltip"
              ></TooltipVT>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TooltipVT from "../components/TooltipVT";

export default {
  name: "OverviewCardsVT",
  components: { TooltipVT },
  props: { config: Array, values: Object },
  data: function () {
    return {
      highlighted: this.config[0].value,
    };
  },
  methods: {
    getLastItemClass(index) {
      const cardsPerRow = this.getCardsPerRow(); // Get the number of cards per row based on screen size
      if ((index + 1) % cardsPerRow === 0) {
        return "pr-0"; // Add pr-0 class to the last card in each row
      } else {
        return "pr-3";
      }
    },
    getCardsPerRow() {
      // Define the number of cards per row based on screen size using media queries
      if (this.$vuetify.breakpoint.smAndDown) {
        return 1; // On mobile, display 1 card per row
      } else if (this.$vuetify.breakpoint.mdAndDown) {
        return 5; // On smaller screens, display 2 cards per row
      } else {
        return 5; // Default: Display 4 cards per row
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}
.pointer {
  cursor: pointer;
}
</style>
